import { Box } from '@mui/material';
import { HomeWork } from '@mui/icons-material';
import { status as statusColors, text } from '../../theme/colors';

/**
 * Stands in for a listing with no photos. role="img" + an explicit label so a
 * screen reader hears "no photo" rather than skipping a silent decorative box.
 */
export default function PhotoPlaceholder({ height = 190, iconSize = 48, sx = {} }) {
  return (
    <Box
      role="img"
      aria-label="No photo available for this property"
      sx={{
        width: '100%', height, display: 'flex', alignItems: 'center', justifyContent: 'center',
        bgcolor: statusColors.neutralBg, ...sx,
      }}
    >
      <HomeWork sx={{ fontSize: iconSize, color: text.tertiary }} />
    </Box>
  );
}
